<div>
  <p class="toolbar-top">
    <mat-toolbar>

      <mat-toolbar-row class="toolbar-white">
        <div class="container">
          <span class="account">Admin</span>
          <span class="spacer"></span>
          <img class="flagdef" src="../../assets/images/pr-flag.png">
        </div>
      </mat-toolbar-row>

      <mat-toolbar-row class="toolbar-red">
        <div class="container">
          <div [ngClass]="{'cursor': isLogged && hasPermission(headerNavEnum.HOME)}" (click)="navigateHome()">
            <img class="img-logo" src="../../assets/images/miclaro-logo.png">
          </div>

          @if (isLogged) {
            <mat-button-toggle-group id="menu-long" class="toolbar-options" name="options" aria-label="Options Toolbar"
              [(ngModel)]="tabSelected" (click)="tabChanged()">
              @for (item of appMenu; track item) {
                @if (item.enable) {
                  <mat-button-toggle [value]="item.endPath">{{item.name}}</mat-button-toggle>
                }
              }
            </mat-button-toggle-group>
          }

          @if (isLogged) {
            <span class="spacer"></span>
          }
          @if (isLogged) {
            <button class="toolbar-options-right" mat-button (click)="logout()">
              <mat-icon class="mat-icon-20" svgIcon="logout_custom"></mat-icon>
              {{name}}
            </button>
          }


          @if (isLogged) {
            <button id="menu-small" class="toolbar-options-mobile" mat-icon-button
              [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon>menu</mat-icon>
            </button>
          }
          <mat-menu #menu="matMenu">
            @for (item of appMenu; track item) {
              <button mat-menu-item (click)="tabSelected = item.endPath; tabChanged()">
                <span>{{item.name}}</span>
              </button>
            }
            <button mat-menu-item (click)="logout()">
              <span>Cerrar Sesion</span>
            </button>
          </mat-menu>
        </div>
      </mat-toolbar-row>


    </mat-toolbar>


  </p>
</div>
